import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom";
import Spinner from "./views/spinner/Spinner";
import "./assets/scss/style.scss"

window.addEventListener('error', (event) => {
  const isChunkError = event?.error?.name === 'ChunkLoadError';
  if (isChunkError) {
    const reloadedKey = 'chunk_reload_attempted';
    const attempts = parseInt(sessionStorage.getItem(reloadedKey) || '0', 10);
    if (attempts < 2) {
      sessionStorage.setItem(reloadedKey, String(attempts + 1));
      window.location.href = window.location.href; // not reload(true) — deprecated
    }
  }
});

// Clear the counter once the page loads successfully
window.addEventListener('load', () => {
  sessionStorage.removeItem('chunk_reload_attempted');
});

const App = lazy(
  () =>
    new Promise((resolve) => {
      setTimeout(() => resolve(import("./app")), 0);
    })
);

ReactDOM.render(
  <Suspense fallback={<Spinner />}>
    <App />
  </Suspense>,
  document.getElementById("root")
);
